/**
 * The Leadgible wordmark — three descending bars and the name.
 *
 * Read off every auth mockup: a `--mdx-wordmark-mark` square in `--mdx-brand`,
 * radius `--mdx-radius-control-sm`, holding three white bars at 15px, 10px and
 * 5px wide; then the name at `--mdx-text-19`, 700, `--mdx-track-verdict`.
 *
 * The descending bars are the product's argument in a logo — a set of leads
 * sorted by score. `DESIGN-SYSTEM.md` §3 calls the Verdict the signature; this
 * is its 28px echo.
 *
 * Story 3.3.
 */
export function Wordmark() {
  return (
    <a
      href="/"
      aria-label="Leadgible, home"
      // No `self-start`: on the two-column screens the column is a left-aligned
      // stack and it sits left anyway, while `auth-verify` centres it. Pinning
      // it start-ward made the centred layout render it off to one side.
      className="inline-flex items-center gap-mdx-10 rounded-mdx-control p-mdx-2 no-underline"
    >
      <span
        aria-hidden="true"
        className="flex size-mdx-wordmark-mark shrink-0 flex-col items-center justify-center gap-mdx-2 rounded-mdx-control-sm bg-mdx-brand"
      >
        <span className="h-mdx-2 w-mdx-16 rounded-mdx-sm bg-mdx-white" />
        <span className="h-mdx-2 w-mdx-10 rounded-mdx-sm bg-mdx-white" />
        <span className="h-mdx-2 w-mdx-6 rounded-mdx-sm bg-mdx-white" />
      </span>
      <span className="text-mdx-19 font-mdx-bold tracking-mdx-verdict text-mdx-ink">Leadgible</span>
    </a>
  )
}
